import React, { useEffect, useRef, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Row, Col, InputGroup, FormText, Table } from "react-bootstrap";
import Select from "react-select";
import {
  IconUser,
  IconFileText,
  IconCurrencyDollar,
  IconWorldWww,
  IconEdit,
} from "@tabler/icons-react";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import SkuEditPopup from "./SkuEditPopup";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
function ProductStep1({
  isEditing,
  selectedOptionSimple,
  setSelectedOptionSimple,
}) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const { sku_id } = useParams();

  const {
    data: result,
    isLoading: resultLoading,
    postData: validateSkuId,
  } = usePostRequest(API_ENDPOINTS.VALIDATE_SKUID);

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isDeptHead = user?.is_finance_department_head;

  const [suggestionData, setSuggestionData] = useState([]);
  const [showVendorId, setShowVendorId] = useState(false);
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const { data: vendors, postData: fetchVendors } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );
  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const displayName = watch("skuId");
  const skuIdUnique = watch("skuIdUnique");
  const prodId = watch("productId");

  const suggestionBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        setSuggestionData(null);
        setSearchDebounces({ searchName: "" });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchVendors(
        {
          search:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
          page: 1,
          limit: 500,
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const openOrderPopup = () => {
    setShowCreateOrder(true);
  };

  const ProductTypeSelected = watch("Type");
  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  // useEffect(() => {
  //   if (!ProductTypeSelected) {
  //     setValue("Type", "inventory");
  //   }
  // }, [setValue, ProductTypeSelected]);

  useEffect(() => {
    if (!ProductTypeSelected) {
      setValue("Type", "product");
    }
  }, [setValue, ProductTypeSelected]);

  const {
    data: fetchContractdata,
    isLoading: contractLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { data: vendorSku, postData: fetchVendorSku } = usePostRequest(
    API_ENDPOINTS.GET_VENDOR_SKU,
  );

  // useEffect(() => {
  //   fetchVendors({ page: 1, limit: 500 });
  // }, []);

  useEffect(() => {
    fetchContract();
  }, []);

  const handleSelectVendor = (item) => {
    setValue("vendor", item?.display_name);
    setValue("vendor_id", item?.VendorContact?.vendor_id);
    setSuggestionData([]);
    setSearchDebounces({ searchName: "" });
    console.log("item", item);
  };

  const onValidateSuccess = (data) => {
    console.log("validate success", data);
  };

  const vendorId = watch("vendor_id");
  const formVendorSku = watch("vendor_sku");

  useEffect(() => {
    // Don't fetch/overwrite an existing vendor SKU.
    // This is important for edit mode and existing form data.
    if (!vendorId || formVendorSku) return;

    fetchVendorSku(
      { vendor_id: vendorId },
      (res) => {
        if (res?.vendor_sku) {
          setValue("vendor_sku", res.vendor_sku, {
            shouldDirty: false,
            shouldValidate: false,
          });
        }
      },
      (error) => {
        console.error("Failed to fetch vendor SKU:", error);
      },
    );
  }, [vendorId, formVendorSku, fetchVendorSku, setValue]);

  const onValidateError = (data) => {
    toast.error(
      data?.message ||
      "Product already exists with this SKU, please choose another SKU",
    );
    setValue("skuId", "");
  };

  const validateSku = (name) => {
    if (name && name.trim().length > 0) {
      const trimmedName = name.trim();

      const payload = {
        sku_display_name: trimmedName,
      };
      validateSkuId(payload, onValidateSuccess, onValidateError);
    }
  };

  return (
    <>
      <SkuEditPopup
        show={showCreateOrder}
        onClose={() => setShowCreateOrder(false)}
        rfqId={displayName}
        mainSku={skuIdUnique}
        prodsId={prodId}
      />
      <Row className="mb-3 mt-3 d-flex">
        <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
              Product Type:
            </Form.Label>

            {/* <Form.Check>
              <Form.Check.Input
                type="radio"
                id="inventory"
                value="inventory"
                {...register("Type")}
              />
              <Form.Check.Label htmlFor="inventory">Inventory</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="non-inventory"
                value="non-inventory"
                {...register("Type")}
              />

              <Form.Check.Label htmlFor="RFIId">Non-Inventory</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="kit"
                value="kit"
                {...register("Type")}
              />

              <Form.Check.Label htmlFor="kit">Kit</Form.Check.Label>
            </Form.Check> */}
            {isEditing && ["inventory", "non-inventory"].includes(ProductTypeSelected) && (
              <>
                <Form.Check>
                  <Form.Check.Input type="radio" id="inventory" value="inventory" {...register("Type")} />
                  <Form.Check.Label htmlFor="inventory">Inventory (legacy)</Form.Check.Label>
                </Form.Check>
                <Form.Check>
                  <Form.Check.Input type="radio" id="non-inventory" value="non-inventory" {...register("Type")} />
                  <Form.Check.Label htmlFor="non-inventory">Non-Inventory (legacy)</Form.Check.Label>
                </Form.Check>
              </>
            )}
            
            <Form.Check>
              <Form.Check.Input type="radio" id="product" value="product" {...register("Type")} />
              <Form.Check.Label htmlFor="product">Product</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input type="radio" id="kit" value="kit" {...register("Type")} />
              <Form.Check.Label htmlFor="kit">Kit</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input type="radio" id="service" value="service" {...register("Type")} />
              <Form.Check.Label htmlFor="service">Service</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input type="radio" id="consumable_material" value="consumable_material" {...register("Type")} />
              <Form.Check.Label htmlFor="consumable_material">Consumable/Material</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input type="radio" id="other" value="other" {...register("Type")} />
              <Form.Check.Label htmlFor="other">Other</Form.Check.Label>
            </Form.Check>

          </div>
        </Form.Group>
        {/* <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
              Variant:
            </Form.Label>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="True"
                value="True"
                disabled={ProductTypeSelected === "kit"}
                {...register("variant")}
              />
              <Form.Check.Label htmlFor="True">Yes</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="False"
                value="False"
                disabled={ProductTypeSelected === "kit"}
                {...register("variant")}
              />

              <Form.Check.Label htmlFor="False">No</Form.Check.Label>
            </Form.Check>
          </div>
        </Form.Group> */}
      </Row>

      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Internal SKU</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                name="vendor_sku"
                {...register("vendor_sku")}
                placeholder="Auto-generated"
                disabled
              />
            </InputGroup>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <div className="d-flex align-items-center justify-content-between">
              <Form.Label className="required">Vendor SKU</Form.Label>
              {/* {(isSuperAdmin || isDeptHead) && sku_id && ( */}
              {["kajal@aspettoinc.com", "andrii@aspettoinc.com"].includes(
                user?.email,
              ) &&
                sku_id && (
                  <span
                    className="trash_icon"
                    onClick={openOrderPopup}
                    style={{ cursor: "pointer" }}
                  >
                    <IconEdit size={20} stroke={1} />
                  </span>
                )}
            </div>
            <InputGroup className="mb-3">
              <Form.Control
                disabled={isEditing}
                name="skuId"
                {...register("skuId")}
                placeholder="Enter SKU"
                onBlur={(e) => validateSku(e.target.value)}
              />
              <InputGroup.Text id="basic-addon2">
                <IconUser />
              </InputGroup.Text>
            </InputGroup>
            {errors.skuId && (
              <span className="text-danger">{errors.skuId.message}</span>
            )}
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <Form.Label>Product Name</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                name="name"
                {...register("name")}
                placeholder="Enter Product Name"
              />
              <InputGroup.Text id="basic-addon2">
                <IconUser />
              </InputGroup.Text>
            </InputGroup>
            {errors.name && (
              <span className="text-danger">{errors.name.message}</span>
            )}
          </Form.Group>
        </Col>

        {showVendorId && (
          <>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Vendor ID</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    {...register("vendor_id")}
                    placeholder="Enter vendor id"
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Product ID</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    name="name"
                    {...register("productId")}
                    placeholder="Enter Product Name"
                  />
                  <InputGroup.Text id="basic-addon2">
                    <IconUser />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>SKU ID</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    name="name"
                    {...register("skuIdUnique")}
                    placeholder="Enter Product Name"
                  />
                  <InputGroup.Text id="basic-addon2">
                    <IconUser />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
          </>
        )}
        <Col md={3}>
          <Form.Group>
            <Form.Label className="required">Vendor</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                {...register("vendor")}
                placeholder="Select Vendor"
                onChange={handleSearchByName}
              />
            </InputGroup>
            <div>
              {suggestionData?.data?.length > 0 &&
                searchDebounces?.searchName?.length > 0 && (
                  <div className="suggestions_box" ref={suggestionBoxRef}>
                    <div className="table-responsive">
                      <Table>
                        <tbody>
                          {suggestionData?.data?.map((item, index) => (
                            <tr
                              key={index}
                              onClick={() => handleSelectVendor(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <td>{item?.display_name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
            </div>
            {errors.vendor && (
              <span className="text-danger">{errors.vendor.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Description (Purchase)</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("description")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter Description"
              />
              <InputGroup.Text id="basic-addon2">
                <IconFileText />
              </InputGroup.Text>
            </InputGroup>
            {errors.description && (
              <span className="text-danger">{errors.description.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Description (Sales)</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                as="textarea"
                name="Enter description"
                {...register("salesDescription")}
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                placeholder="Enter Description"
              />
              <InputGroup.Text id="basic-addon2">
                <IconFileText />
              </InputGroup.Text>
            </InputGroup>
            {errors.salesDescription && (
              <span className="text-danger">
                {errors.salesDescription.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        {/* <Col xs={6} className="mb-3">
          <Form.Group className="mb-3">
            <Form.Label>Contract Vehicle</Form.Label>
            <Select
              // {...register("contractvehicle")}
              isMulti
              value={selectedOptionSimple}
              defaultValue={selectedOptionSimple}
              onChange={setSelectedOptionSimple}
              className="basic-multi-select"
              options={fetchContractdata?.data?.map((item, index) => ({
                label: item?.name,
                value: item?.id,
              }))}
            />
            {errors.contractvehicle && (
              <span className="text-danger">
                {errors.contractvehicle.message}
              </span>
            )}
          </Form.Group>
        </Col> */}
        <Col xs={4}>
          <Form.Group>
            <Form.Label>UM (Unit of Measure)</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control name="uoi" {...register("uoi")} placeholder="UM" />
            </InputGroup>
            {errors.uoi && (
              <span className="text-danger">{errors.uoi.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col xs={4}>
          <Form.Group>
            <Form.Label className="">Cost</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                type="number"
                name="cost"
                {...register("cost")}
                placeholder="0.00"
                step="any"
              />
              <InputGroup.Text id="basic-addon2">
                <IconCurrencyDollar />
              </InputGroup.Text>
            </InputGroup>
            {errors.cost && (
              <span className="text-danger">{errors.cost.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col xs={4}>
          <Form.Group>
            <Form.Label className="">Customer Price</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                type="number"
                name="customer_price"
                step="any"
                {...register("customer_price")}
                placeholder="0.00"
              />
              <InputGroup.Text id="basic-addon2">
                <IconCurrencyDollar />
              </InputGroup.Text>
            </InputGroup>
            {errors.customer_price && (
              <span className="text-danger">
                {errors.customer_price.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}

export default ProductStep1;
